import { useEffect, useState } from 'react'
import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride'
import { useAdminStore } from '@/store/adminStore'
import { useTranslation } from 'react-i18next'

export function TimetableAdminTour() {
  const { timetableTour, completeTimetableTour, nextTimetableStep } = useAdminStore()
  const [isRunning, setIsRunning] = useState(false)
  const { t } = useTranslation('tour')
  // Start tour when timetableTour.isActive changes
  useEffect(() => {
    if (timetableTour.isActive && !isRunning) {
      setIsRunning(true)
    }
  }, [timetableTour.isActive, isRunning])
  //  if (finishedStatuses.includes(status)) {
  //      setIsRunning(false)


  const steps: Step[] = [
    {
      target: 'body',
      content: t('admin.timetableAdminTour.steps.welcome.content'),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '#timetable-generator',
      content: t('admin.timetableAdminTour.steps.generator.content'),
      disableBeacon: true,
    },
    {
      target: '#input-section',
      content: t('admin.timetableAdminTour.steps.inputSection.content'),
    },
    {
      target: '#constraints-section',
      content: t('admin.timetableAdminTour.steps.constraintsSection.content'),
    },
    {
      target: '#generate-button',
      content: t('admin.timetableAdminTour.steps.generateButton.content'),
    },
    {
      target: '#view-timetable',
      content: t('admin.timetableAdminTour.steps.viewTimetable.content'),
    },
    {
      target: '#export-options',
      content: t('admin.timetableAdminTour.steps.exportOptions.content'),
    },
  ]

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data
    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED]

    if (finishedStatuses.includes(status)) {
      setIsRunning(false)
      completeTimetableTour()
    } else if (status === STATUS.RUNNING) {
      nextTimetableStep()
    }
  }

  useEffect(() => {
    // Add any cleanup or side effects if needed
    return () => {
      if (timetableTour.isActive) {
        completeTimetableTour()
      }
    }
  }, [timetableTour.isActive, completeTimetableTour])

  return (
    <>
      <Joyride
        disableOverlayClose={true}
        callback={handleJoyrideCallback}
        continuous
        hideCloseButton
        hideBackButton
        scrollToFirstStep
        showProgress
        showSkipButton
        steps={steps}
        run={isRunning}
        stepIndex={timetableTour.currentStep}
        styles={{
          options: {
            primaryColor: '#ffffff',
            zIndex: 10000,
            arrowColor: '#ffffff',
            backgroundColor: '#ffffff',
          },
          buttonNext: {
            backgroundColor: '#ffffff',
            color: '#525FE1',
            fontSize: '16px',
            padding: '10px 20px',
            borderRadius: '6px',
          },
          buttonBack: {
            color: '#666',
            fontSize: '16px',
            padding: '10px',
            marginRight: '12px',
          },
          buttonSkip: {
            color: '#666',
            fontSize: '16px',
            padding: '10px',
          },
          tooltip: {
            padding: '24px',
            borderRadius: '12px',
            backgroundColor: '#ffffff',
            color: '#333',
            fontSize: '16px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            maxWidth: '500px',
            minWidth: '300px',
            pointerEvents: 'auto' as const,
            transition: 'opacity 0.2s ease',
          },
          tooltipContainer: {
            textAlign: 'left' as const,
          },
          spotlight: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)', // White highlight
            border: '2px solid white', // White border
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        }}
        locale={{
          back: t('admin.timetableAdminTour.locale.back'),
          close: t('admin.timetableAdminTour.locale.close'),
          last: t('admin.timetableAdminTour.locale.last'),
          next: t('admin.timetableAdminTour.locale.next'),
          skip: t('admin.timetableAdminTour.locale.skip')
        }}
      />
      
      {/* Dark overlay for consistent darkening */}
      {isRunning && timetableTour.currentStep === 0 && (
        <div 
          className="fixed inset-0 bg-black/70 z-[9999] pointer-events-none"
          style={{ transition: 'opacity 0.2s ease' }}
        />
      )}
    </>
  )
} 